exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tree-map-node {\n  font: 10px sans-serif;\n  overflow: hidden;\n  position: absolute;\n  text-indent: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 12px;\n  text-align: center;\n  line-height: 1.4;\n  word-break: break-all;\n  padding: 0 5px;\n}\n\n.cell-label {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.node {\n  box-sizing: border-box;\n  position: absolute;\n  overflow: hidden;\n}\n\n.node-label {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  font-size: 12px;\n}\n\n.node-name {\n  max-width: 100%;\n  word-break: break-all;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/treeMap/styles.scss
// module id = 2000
// module chunks = 0